import React from 'react';
import { Table, Tag } from 'antd';
import type { FINExchangeRate } from '../../../services/exchangeRateApi';

interface Props {
  records: FINExchangeRate[];
  total: number;
  page: number;
  pageSize: number;
  currentIdx: number;
  disabled: boolean;
  onSelect: (idx: number) => void;
  onPageChange: (page: number) => void;
}

const BrowseTab: React.FC<Props> = React.memo(({
  records, total, page, pageSize, currentIdx, disabled,
  onSelect, onPageChange,
}) => {
  const columns = [
    {
      title: '幣別',
      dataIndex: 'f10e_01',
      width: 80,
    },
    {
      title: '匯率日期',
      dataIndex: 'f10e_02',
      width: 120,
      render: (v: string | null) => v?.slice(0, 10) || '',
    },
    {
      title: '預估匯率',
      dataIndex: 'f10e_12',
      width: 120,
      align: 'right' as const,
      render: (v: number) => v?.toFixed(4),
    },
    {
      title: '即期匯率',
      dataIndex: 'f10e_13',
      width: 120,
      align: 'right' as const,
      render: (v: number) => v?.toFixed(4),
    },
    {
      title: '進口報關匯率',
      dataIndex: 'f10e_11',
      width: 130,
      align: 'right' as const,
      render: (v: number) => v?.toFixed(4),
    },
    {
      title: '出口報關匯率',
      dataIndex: 'exp_customs_rate',
      width: 130,
      align: 'right' as const,
      render: (v: number) => v?.toFixed(4),
    },
    {
      title: '啟用',
      dataIndex: 'is_active',
      width: 60,
      align: 'center' as const,
      render: (v: boolean) => v ? <Tag color="green">是</Tag> : <Tag>否</Tag>,
    },
    {
      title: '無效',
      dataIndex: 'is_valid',
      width: 60,
      align: 'center' as const,
      render: (v: boolean) => v ? <Tag color="red">是</Tag> : <Tag>否</Tag>,
    },
    {
      title: '建檔人員',
      dataIndex: 'user_name',
      width: 100,
    },
    {
      title: '建檔日期',
      dataIndex: 'cdate',
      width: 150,
      render: (v: string | null) => v?.slice(0, 19) || '',
    },
  ];

  return (
    <Table
      dataSource={records}
      columns={columns}
      rowKey={(r) => `${r.f10e_01}_${r.f10e_02?.slice(0, 10)}`}
      size="small"
      scroll={{ x: 1100 }}
      pagination={{
        current: page,
        pageSize,
        total,
        onChange: onPageChange,
        showTotal: (t) => `共 ${t} 筆`,
        showSizeChanger: false,
      }}
      onRow={(_, index) => ({
        onClick: () => { if (!disabled && index !== undefined) onSelect(index); },
        style: index === currentIdx ? { background: '#e6f7ff', cursor: 'pointer' } : { cursor: 'pointer' },
      })}
    />
  );
});

BrowseTab.displayName = 'BrowseTab';
export default BrowseTab;
